// extracted by mini-css-extract-plugin
module.exports = {"loader":"CDI5T","loaderPlaceholder":"UOvE_","secWrap":"thHcN","gridView":"uQsI4","colWrap":"nIDFC","colLeft":"QVjVr","colRight":"BM19w"};